import type { LinkProps } from '@atlassian/help-center-common-component/analytics/link';
import { Link } from '@atlassian/help-center-common-component/analytics/link';
import styled, { css } from 'styled-components';
import { token } from '@atlaskit/tokens';

export const style = css<LinkProps>`
    color: ${(props) => token('color.link', props.theme.color)};

    &:hover {
        color: ${(props) => token('color.link', props.theme.color)};
    }
`;

const ThemedLink = styled(Link)`
    ${style};
`;

export default ThemedLink;
